<script>
import Accordion from '@/components/Accordion/Main';
import AccordionItem from '@/components/Accordion/Item';

export default {
  props: {},
  components: {
    Accordion,
    AccordionItem,
  },
};
document.querySelector('#app').classList.add('overflow-hidden');
</script>

<template>
  <div class="section section_gray section_indents">
    <div class="container">
      <div class="flex flex-col lg:flex-row">
        <div class="w-full lg:w-2/3 xl:w-3/4 mr-5">
          <h2 class="title-h2 mb-6">Ответы на популярные вопросы</h2>
          <accordion>
            <accordion-item>
              <template #accordion-trigger>
                <p class="text-gray-600">
                  Можно&nbsp;ли купить Volkswagen Jetta в&nbsp;кредит?
                </p>
              </template>

              <template #accordion-content>
                <p class="text-gray-600">
                  Да, у&nbsp;нас есть выгодные кредитные программы
                  с&nbsp;низкими процентными ставками. Мы&nbsp;подберем лучшие
                  условия для вашего бюджета.
                </p>
              </template>
            </accordion-item>

            <accordion-item>
              <template #accordion-trigger>
                <p class="text-gray-600">
                  Как проверить техническое состояние подержанного автомобиля?
                </p>
              </template>

              <template #accordion-content>
                <p>
                  При покупке в&nbsp;&laquo;Прагматике&raquo; авто проходит
                  полную диагностику. Мы&nbsp;предоставляем отчет
                  о&nbsp;пробеге, ремонтах и&nbsp;текущем состоянии.
                </p>
              </template>
            </accordion-item>

            <accordion-item>
              <template #accordion-trigger>
                <p>Как работает программа Trade-In?</p>
              </template>

              <template #accordion-content>
                <p>
                  Вы&nbsp;можете обменять свой старый автомобиль
                  на&nbsp;Volkswagen Jetta. Мы&nbsp;проведём оценку
                  и&nbsp;зачтем стоимость вашего авто в&nbsp;оплату нового, что
                  сэкономит ваше время и&nbsp;деньги.
                </p>
              </template>
            </accordion-item>
          </accordion>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
p {
  color: #81869a;
}
</style>
